import { render, staticRenderFns } from "./CustomFieldTableDisplay.vue?vue&type=template&id=d87bcc38"
import script from "./CustomFieldTableDisplay.vue?vue&type=script&lang=js"
export * from "./CustomFieldTableDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports